import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/mobile/shevron_right.svg'
import _imports_1 from '@/assets/images/spb.png'
import _imports_2 from '@/assets/images/russia.png'
import _imports_3 from '@/assets/images/globe.png'
import _imports_4 from '@/assets/images/school.png'
import _imports_5 from '@/assets/images/medicine.png'
import _imports_6 from '@/assets/images/ships.png'


const _withScopeId = n => (_pushScopeId("data-v-5e8c06a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col px-10" }
const _hoisted_2 = { class: "flex items-center justify-center relative mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_8 = { class: "flex justify-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import { toRefs, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, EffectCoverflow } from 'swiper/modules';
import { useGlobalStore } from '@/stores/global';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';


export default /*#__PURE__*/_defineComponent({
  __name: 'FifthSection',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const globalStore = useGlobalStore();
const { categories } = toRefs(globalStore);

const fbCategories = computed(() => categories.value.data?.slice(0, 3));
const sbCaterories = computed(() => categories.value.data?.slice(3));

const onCategory = (id: number) => {
    router.push({
        name: 'category',
        params: { id },
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseButton, {
        text: _unref(t)('main-page.tours.title'),
        type: "subtitle-m",
        "padding-x": "64",
        "padding-y": "12",
        color: "var(--black-color)",
        ui: "primary"
      }, null, 8, ["text"]),
      _createElementVNode("div", {
        class: "absolute right-0 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/categories')))
      }, _hoisted_4)
    ]),
    _createVNode(_unref(Swiper), {
      effect: "coverflow",
      "slides-per-view": 3,
      modules: [_unref(Pagination), _unref(EffectCoverflow)],
      coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 5,
                slideShadows: false,
            },
      centeredSlides: "",
      "grab-cursor": "",
      pagination: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onCategory(fbCategories.value[0].id)))
            }, [
              _hoisted_5,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.spb'),
                    type: "subtitle2-m"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onCategory(fbCategories.value[1].id)))
            }, [
              _hoisted_6,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.russia'),
                    type: "subtitle2-m"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onCategory(fbCategories.value[2].id)))
            }, [
              _hoisted_7,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.foreign'),
                    type: "subtitle2-m"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modules"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(BaseLine, { width: "127" })
    ]),
    _createVNode(_unref(Swiper), {
      effect: "coverflow",
      "slides-per-view": 3,
      modules: [_unref(Pagination), _unref(EffectCoverflow)],
      coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 5,
                slideShadows: false,
            },
      centeredSlides: "",
      "grab-cursor": "",
      pagination: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (onCategory(sbCaterories.value[0].id)))
            }, [
              _hoisted_9,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.school'),
                    type: "subtitle2-m",
                    class: "whitespace-nowrap"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (onCategory(sbCaterories.value[2].id)))
            }, [
              _hoisted_10,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.medicine'),
                    type: "subtitle2-m",
                    class: "text-center"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: "flex flex-col w-[150px] gap-y-6 items-center justify-center",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (onCategory(sbCaterories.value[1].id)))
            }, [
              _hoisted_11,
              isActive
                ? (_openBlock(), _createBlock(BaseTypography, {
                    key: 0,
                    text: _unref(t)('main-page.tours.water'),
                    type: "subtitle2-m"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}
}

})